import {
  Form,
  useActionData,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import { toast } from "react-toastify";

import SalaryField from "../../../../components/SalaryField";
import AddCandidate from "./AddCandidate";
import AppliedCandidates from "./AppliedCandidates";
import { API_BASE_URL, profileImgSrc } from "../../../../config";

import SearchSkillsAll from "../../../../components/SearchSkillsAll";

import { getAdminAuthToken } from "../../../../auth/auth";
import { useEffect, useState } from "react";

import Loader from "../../../../components/Loader";
import JobPreferences from "../../../../components/JobPreferences";

export default function JobFormDash() {
  const [candidates, setCandidates] = useState([]);
  const [toastShown, setToastShown] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const navigation = useNavigation();
  const [loadingJob, isLoadingJob] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [searchCompanies, setSearchCompanies] = useState("");
  const [loadingCompanies, setIsLoadingCompanies] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const location = useLocation();
  const [fields, setFields] = useState({
    company_id: "",
    description: "",
    employment_type: "",
    id: "",
    preferences: [],
    languages: "",
    minimum_bonus: "",
    min_salary: "",
    position: "",
    status: "",
    title: "",
  });
  const token = getAdminAuthToken();

  const isSubmitting = navigation.state === "submitting";

  const errorData = useActionData();
  const isEditMode = !!id;

  let buttonText = isEditMode ? "Edit Job" : "Create job";

  useEffect(() => {
    const fetchJob = async () => {
      if (!isEditMode) return;
      isLoadingJob(true);

      const response = await fetch(`${API_BASE_URL}/admin/jobs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      console.log("edit", result);

      setFields({
        company_id: result.job.company_id,
        description: result.job.description || "",
        employment_type: result.job.employment_type || "",
        id: result.job.id,
        languages: result.job.languages || "",
        minimum_bonus: result.job.minimum_bonus || "",
        min_salary: result.job.min_salary || "",
        position: result.job.position || "",
        status: result.job.status || "0",
        title: result.job.title || "",
        skills: result.job.skills || [],
        preferences: result.job.preferences || [],
      });

      setCandidates(result.job.candidates);

      setSelectedCompany({
        name: result?.job.company.company_name,
        email: result?.job.company.email,
        avatar: result?.job.company.avatar,
      });

      setIsSelected(true);
      isLoadingJob(false);
    };
    fetchJob();
  }, []);

  const handleSkillsChange = (selectedSkillsArray) => {
    setFields((prev) => ({
      ...prev,
      skills: selectedSkillsArray,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFields((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (!toastShown && errorData?.success && errorData.jobId) {
      toast.success(errorData.message);
      setToastShown(true);

      setTimeout(() => {
        navigate(`/admin/jobs/edit-company-job/${errorData.jobId}`, {
          state: { fromJobCreate: true },
        });
      }, 300);
    }

    if (!toastShown && errorData?.error) {
      toast.error(errorData.message || "Something went wrong.");
      setToastShown(true);
    }
  }, [errorData, toastShown]);

  useEffect(() => {
    setToastShown(false);
  }, []);

  useEffect(() => {
    if (location.state?.fromJobCreate) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.state]);

  const handleCompanies = async (searchCompanies = "") => {
    setIsLoadingCompanies(true);
    const params = new URLSearchParams();

    if (searchCompanies.trim()) params.append("company", searchCompanies);

    const response = await fetch(
      `${API_BASE_URL}/admin/companies?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const results = await response.json();

    if (results.success === false) {
      return { error: results.error || "Could not fetch companies" };
    }

    setCompanies(results.data);
    setIsLoadingCompanies(false);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      handleCompanies(searchCompanies);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchCompanies]);

  const handleSelectCompany = (company) => {
    setFields((prev) => {
      return {
        ...prev,
        company_id: company.id,
      };
    });
    setSelectedCompany(company);
    setIsSelected(true);
  };

  const handleDeleteCompany = () => {
    setFields((prev) => {
      return {
        ...prev,
        company_id: "",
      };
    });
    setSelectedCompany(null);
    setIsSelected(false);
  };

  const handlePreferences = (prefObj) => {
    setFields((prev) => {
      const alreadySelected = prev.preferences.some((p) => p.id === prefObj.id);

      return {
        ...prev,
        preferences: alreadySelected
          ? prev.preferences.filter((p) => p.id !== prefObj.id)
          : [...prev.preferences, prefObj],
      };
    });
  };

  return (
    <>
      <div className="create-job-dash-wrapper">
        <div className="row-essy">
          <div className="col-essy-lg-6 col-essy-md-6">
            <Form method="post">
              <div className="create-job-dash-form">
                <h3>{isEditMode ? "Edit Job" : "Create a job"}</h3>

                {loadingJob ? (
                  <Loader />
                ) : (
                  <>
                    <div className="form-group">
                      <label>
                        {isSelected ? "Choosed Company" : "Choose Company"}
                      </label>
                      {!isSelected && (
                        <input
                          type="search"
                          placeholder="Search Companies"
                          value={searchCompanies}
                          onChange={(e) => setSearchCompanies(e.target.value)}
                        />
                      )}

                      <div className="list-companies-wrapper-parent">
                        {isSelected && selectedCompany ? (
                          <div className="list-company-single">
                            <div className="list-company-single__left">
                              <div className="list-company-single__left--img">
                                <img
                                  src={
                                    selectedCompany.avatar === null
                                      ? profileImgSrc
                                      : selectedCompany.avatar
                                  }
                                  alt="company img"
                                />
                              </div>
                              <div className="list-company-single__left--info">
                                <h4>{selectedCompany.name}</h4>
                                <p>{selectedCompany.email}</p>
                              </div>
                            </div>
                            <div className="list-company-single__right">
                              {isEditMode ? null : (
                                <button
                                  type="button"
                                  onClick={handleDeleteCompany}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                            <input
                              type="hidden"
                              name="company_id"
                              value={fields.company_id}
                            />
                          </div>
                        ) : loadingCompanies ? (
                          <Loader />
                        ) : (
                          <div className="list-companies-wrapper">
                            {companies.length > 0 ? (
                              companies.map((curr) => (
                                <div
                                  className="list-company-single"
                                  key={curr.id}
                                >
                                  <div className="list-company-single__left">
                                    <div className="list-company-single__left--img">
                                      <img
                                        src={
                                          curr.avatar === null
                                            ? profileImgSrc
                                            : curr.avatar
                                        }
                                        alt="company img"
                                      />
                                    </div>
                                    <div className="list-company-single__left--info">
                                      <h4>{curr.name}</h4>
                                      <p>{curr.email}</p>
                                    </div>
                                  </div>
                                  <div className="list-company-single__right">
                                    <button
                                      type="button"
                                      onClick={() => handleSelectCompany(curr)}
                                    >
                                      Select
                                    </button>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p>Companies not found</p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Job Status</label>
                      <select
                        name="status"
                        onChange={handleChange}
                        value={fields.status}
                      >
                        <option value="0">Open</option>
                        <option value="1">In review</option>
                        <option value="2">Closed</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>Job Name</label>
                      <input
                        type="text"
                        name="title"
                        onChange={handleChange}
                        value={fields.title}
                      />
                    </div>

                    <div className="form-group">
                      <label>Position</label>
                      <input
                        type="text"
                        name="position"
                        onChange={handleChange}
                        value={fields.position}
                      />
                    </div>

                    <SearchSkillsAll
                      handleSkillsChange={handleSkillsChange}
                      details={fields}
                    />

                    <div className="create-job-salary-wrapper">
                      <SalaryField
                        label="Minimum base salary"
                        name="min_salary"
                        placeholder="150,000"
                        handleInput={handleChange}
                        value={fields.min_salary || ""}
                      />
                      <SalaryField
                        label="Minimum bonus / comission"
                        name="minimum_bonus"
                        placeholder="150,000"
                        handleInput={handleChange}
                        value={fields.minimum_bonus || ""}
                      />
                    </div>

                    <div className="form-group form-group-radio">
                      <label>
                        <input
                          type="radio"
                          name="employment_type"
                          value="Full Time"
                          onChange={handleChange}
                          defaultChecked={
                            fields.employment_type === "Full Time"
                          }
                        />
                        <span>Full time</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="employment_type"
                          value="Part Time"
                          onChange={handleChange}
                          defaultChecked={
                            fields.employment_type === "Part Time"
                          }
                        />
                        <span>Part Time</span>
                      </label>
                    </div>

                    <JobPreferences
                      handlePreferences={handlePreferences}
                      details={fields}
                    />

                    <div className="form-group">
                      <label>Required Languages</label>
                      <input
                        type="text"
                        name="languages"
                        placeholder="English..."
                        onChange={handleChange}
                        value={fields.languages}
                      />
                    </div>

                    <div className="form-group">
                      <label>Job Description</label>
                      <textarea
                        name="description"
                        onChange={handleChange}
                        value={fields.description}
                      ></textarea>
                    </div>

                    <button type="submit" className="btn-all-white">
                      {isSubmitting ? "Saving job..." : buttonText}
                    </button>
                  </>
                )}
              </div>
            </Form>
          </div>
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="dash-add-canditate">
              <h3>Candidates</h3>
              <AddCandidate candidates={candidates} loadingJob={loadingJob} />
              <AppliedCandidates />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const createJobAction = async ({ request, params }) => {
  const formData = await request.formData();
  const jobId = params.id;
  const token = getAdminAuthToken();

  const data = new FormData();

  const url = !jobId
    ? `${API_BASE_URL}/admin/create-job`
    : `${API_BASE_URL}/admin/jobs/update/${jobId}`;

  data.append("company_id", formData.get("company_id"));
  data.append("status", formData.get("status"));
  data.append("title", formData.get("title"));
  data.append("position", formData.get("position"));

  const skillsRaw = JSON.parse(formData.get("skills"));

  skillsRaw.forEach((id) => {
    data.append("skills[]", id);
  });

  data.append("min_salary", formData.get("min_salary"));
  data.append("minimum_bonus", formData.get("minimum_bonus"));
  data.append("employment_type", formData.get("employment_type"));

  formData.getAll("preferences").forEach((preference) => {
    data.append("preferences[]", preference);
  });

  data.append("languages", formData.get("languages"));
  data.append("description", formData.get("description"));

  // console.log("=== FormData sadržaj ===");
  // for (let [key, value] of data.entries()) {
  //   console.log(key, value);
  // }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: data,
  });

  const result = await response.json();

  if (result.errors) {
    return {
      success: false,
      error: result.errors,
    };
  }

  return {
    success: true,
    jobId: result.job.id,
    message: result.message,
  };
};
